<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.badges', 2),
                        href: meta.links.index,
                    },
                    {
                        name: badge.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <div class="md:grid md:grid-cols-3 lg:grid-cols-6 md:gap-6">
                <div
                    class="flex shrink-0 space-x-2 bg-white rounded-xl p-2"
                    v-for="student in students"
                    :key="student.id"
                >
                    <img
                        :src="student.avatar_or_default"
                        alt=""
                        class="max-w-none h-16 w-16 rounded-full ring-2 ring-white"
                    />
                    <div class="flex flex-col w-full">
                        <div>
                            {{ student.first_name_and_initial }}
                        </div>
                        <div>
                            <svg
                                class="w-6 h-6"
                                :class="student.earned_by_student ? 'text-indigo-400' : 'text-gray-400'"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </div>
                        <div>
                            <ProgressBar
                                v-if="badge.is_automatic"
                                :percent="student.percent"
                                color="indigo"
                                height="sm"
                                :show-text="false"
                                class="mt-1 w-full"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import ProgressBar from '@/components/Gamification/ProgressBar.vue';

export default {
    components: {
        PanelPage,
        ProgressBar,
    },
    layout: Layout,
    name: 'Show',
    props: ['teacher', 'meta', 'options', 'students', 'badge', 'gamificationSet'],
};
</script>
